export function transformQueryParameterToBoolean(queryParameter: string | undefined): boolean {
    if (queryParameter === "true") {
        return true;
    } else {
        return false;
    }
}
